export default "__VITE_ASSET__a4770a54__"